function happyCallDataReducer(state = { questionList: [], happyCallServiceFilters: null, happyCallServiceList: { Data: [], TotalCount: 0 } }, action) {

  switch (action.type) {

    case "FETCH_HAPPYCALL_ANSWERS":
      return {
        ...state,
        questionList: action.data
      };
    case "HAPPY_CALL_SERVICE_FILTER":
      return {
        ...state,
        happyCallServiceFilters: action.data
      }
    case "SEARCH_HAPPY_CALL_SERVICE":
      return {
        ...state,
        happyCallServiceList: action.data
      }
    default:
      return state;
  }
}

export default happyCallDataReducer;